export default "__VITE_ASSET__CJ2mVys2__"